import React, { useState } from 'react'

import { TextBody, get, Button } from '@ally/metronome-ui'
import { Private } from '@ally/private'

import styled from 'styled-components'
import { AccountDetails } from '../../types'
import { NonPrintingWrapper } from '../../utils/NonPrintingWrapper'
import { maskAccountNumber } from '../../utils/formatter'

interface AccountDetailsProps {
  account: AccountDetails
}

const AcctNumToggle = styled.span`
  display: flex;
  flex-flow: row wrap;
`

const ShowHideButton = styled(Button)`
  margin-left: ${get.space('xxs')};
`

const AcctNumWrapper = styled.span`
  display: inline;
  width: 50%;
  min-width: 130px;
  margin-left: ${get.space('xxs')};
  ${get.media.up('md')} {
    display: inline-block;
  }
`

export const AccountNumberToggle: React.FC<AccountDetailsProps> = ({
  account,
}) => {
  const [showAccountNumber, setShowAccountNumber] = useState(false)
  const buttonContent = showAccountNumber ? 'Hide' : 'Show'

  const toggleShowButtonState = (): void => {
    setShowAccountNumber(prev => !prev)
  }

  return (
    <AcctNumToggle>
      <TextBody tag="span" size="sm" weight="bold">
        Account Number:
      </TextBody>
      <AcctNumWrapper>
        <Private as="span">
          <TextBody
            tag="span"
            size="sm"
            aria-label={`showing the ${
              showAccountNumber ? 'full' : 'abbreviated'
            } account number`}
            aria-live="polite"
          >
            {showAccountNumber
              ? account.accountNumberPvtEncrypt
              : maskAccountNumber(account.accountNumberPvtEncrypt)}
          </TextBody>
        </Private>

        <NonPrintingWrapper>
          <ShowHideButton
            text={buttonContent}
            variant="link"
            onClick={toggleShowButtonState}
            data-testid="toggleNum"
            ariaLabel={
              showAccountNumber
                ? 'Show abbreviated account number'
                : 'Show full account number'
            }
            withAllyTM={`accountNumber-${buttonContent.toLowerCase()}`}
          />
        </NonPrintingWrapper>
      </AcctNumWrapper>
    </AcctNumToggle>
  )
}
